var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4048 7.52877L30.0775 4.20144L11.279 22.9999L30.0775 41.7983L33.4048 38.471L17.9337 22.9999L33.4048 7.52877Z",
    fill: "#810CA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_1344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.1163,
    height: 45.1163,
    fill: "white",
    transform: "matrix(-1 0 0 -1 45.1162 45.5581)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.4739e93d43adaf855786022d0a27f8e5.svg";
export { ForwardRef as ReactComponent };